import React from "react";

const Footer = () => {
  return (
    <footer className="py-5 bg-dark text-white">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 mb-4 mb-lg-0">
            <h5 className="mb-4">
              <img src="/assets/images/logo.png" alt="logo" width="220px" />
            </h5>
            <p>
              Recharge POS is a fast, secure platform for mobile recharges, DTH
              payments, and utility bills. Earn commissions on every transaction
              and enjoy a seamless payment experience.
            </p>
          </div>
          <div className="col-lg-2 col-6 mb-4 mb-lg-0">
            <h5 className="mb-4">Quick Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <a href="#features" className="text-white">
                  Features
                </a>
              </li>
              <li className="mb-2">
                <a href="#screenshots" className="text-white">
                  Screenshots
                </a>
              </li>
              <li className="mb-2">
                <a href="#download" className="text-white">
                  Download
                </a>
              </li>
              <li className="mb-2">
                <a href="#faq" className="text-white">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
          <div className="col-lg-3 col-6 mb-4 mb-lg-0">
            <h5 className="mb-4">Legal</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <a
                  href="https://rechargepos.com/privacy_policy"
                  target="_blank"
                  className="text-white"
                >
                  Privacy Policy
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="https://rechargepos.com/terms_and_conditions"
                  target="_blank"
                  className="text-white"
                >
                  Terms of Service
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="https://rechargepos.com/refund_policy"
                  target="_blank"
                  className="text-white"
                >
                  Refund Policy
                </a>
              </li>
            </ul>
          </div>
          <div className="col-lg-3">
            <h5 className="mb-4">Contact Us</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <i className="fas fa-envelope mr-2"></i>{" "}
                rechargeposapp@gmail.com
              </li>
              <li className="mb-2">
                <i className="fab fa-whatsapp mr-2"></i> +91 7890-25-1220
              </li>
              <li className="mb-2">
                <i class="fas fa-map-marker-alt mr-2"></i> Barasat, Kolkata -
                700126
              </li>
            </ul>
          </div>
        </div>
        <hr className="bg-light my-4" />
        <div className="row">
          <div className="col-md-6 text-center text-md-left">
            <p className="mb-0 small">
              Copyright © 2024 Recharge POS. All rights reserved.
            </p>
          </div>
          <div className="col-md-6 text-center text-md-right">
            <a
              href="https://www.facebook.com/rechargepos"
              target="_blank"
              className="text-white mx-2"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href="https://www.instagram.com/rechargepos/"
              target="_blank"
              className="text-white mx-2"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="https://www.whatsapp.com/channel/0029VarvArf1dAwASjmuD62n"
              target="_blank"
              className="text-white mx-2"
            >
              <i className="fab fa-whatsapp"></i>
            </a>
            <a
              href="https://www.youtube.com/@rechargeposapp"
              target="_blank"
              className="text-white mx-2"
            >
              <i className="fab fa-youtube"></i>
            </a>
            <a
              href="https://t.me/rechargepos"
              target="_blank"
              className="text-white mx-2"
            >
              <i className="fab fa-telegram"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
